module.exports = __webpack_public_path__ + "img/9-9-23.d70f049b.jpg";